export default __webpack_public_path__ + "static/media/36I-102737_-43612_0.c3d1dd5f.jpg";